import React from 'react'

export const _dragModes = {
  solo: 'solo',
  multi: 'multi',
  standalone: 'standalone',
  auto: 'auto',
}

const DraggableItem = ({
  item,
  source,
  allowDrag = false,
  mode = _dragModes.standalone, // 'standalone' | 'solo' | 'multi' | undefined (auto)
  children,
}) => {

  if (!allowDrag) {
    return <>{children}</>
  }

  const onDragStart = (e) => {
    if (!allowDrag) return
    e.dataTransfer.setData(
      'text/plain',
      JSON.stringify({ item, source })
    )
  }

  const dragProps = {
    className: 'dg-i',
    draggable: allowDrag,
    onDragStart,
    style: { cursor: allowDrag ? 'grab' : 'default' },
  }

  const injectProps = (child) => {
    if (!React.isValidElement(child)) return child

    return React.cloneElement(child, {
      ...dragProps,
      className: `${dragProps.className} ${child.props.className ?? ''}`,
      style: {
        ...dragProps.style,
        ...child.props.style,
      },
      onDragStart: (e) => {
        child.props.onDragStart?.(e)
        onDragStart(e)
      },
    })
  }

  // ---------- MODE RESOLUTION ----------
  const childArray = React.Children.toArray(children)
  const resolvedMode =
    mode ??
    (childArray.length > 1 ? 'multi' : 'solo')

  // ---------- MODES ----------
  if (resolvedMode === 'standalone') {
    return (
      <div {...dragProps}>
        {children}
      </div>
    )
  }

  if (resolvedMode === 'multi') {
    return (
      <>
        {childArray.map(injectProps)}
      </>
    )
  }

  // solo (default)
  return injectProps(childArray[0])
}

export default DraggableItem


// const DraggableItem = ({ item, source, allowDrag = false, children }) => {

//   const onDragStart = (e) => {
//     if (!allowDrag) return
//     e.dataTransfer.setData(
//       'text/plain',
//       JSON.stringify({ item, source })
//     )
//   }

//   return (
//     <div className='dg-i' draggable={allowDrag} onDragStart={onDragStart} style={{ cursor: 'grab' }}>
//       {children}
//     </div>
//   )
// }

// export default DraggableItem

